import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const VideoWrapper = styled.div`
      position: relative;
      padding-bottom: 56.25%; /* 16:9 */
      padding-top: 25px;
      height: 0;
    `
const IFrame = styled.iframe`
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    `

export default function ViewYoutubePlaylistMedia(props) {
  const { listId, siParam } = props

  const embedUrl = siParam
    ? `https://www.youtube.com/embed/videoseries?list=${listId}&si=${siParam}`
    : `https://www.youtube.com/embed/videoseries?list=${listId}`

  return (
    <React.Fragment>
      <VideoWrapper>
        <IFrame
          src={embedUrl}
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
        />
      </VideoWrapper>
    </React.Fragment>
  )
}

ViewYoutubePlaylistMedia.propTypes = {
  listId: PropTypes.string.isRequired,
  siParam: PropTypes.string,
}
